export default __webpack_public_path__ + "static/sm-891faeee2077481878c1a67a5fa7570c.svg";